
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.65 9.04l-4.84-.42-1.89-4.45a1 1 0 00-1.84 0L9.19 8.63l-4.83.41a1 1 0 00-.57 1.75l3.67 3.18-1.1 4.72a1 1 0 001.49 1.08l4.15-2.5 4.15 2.51a1 1 0 001.49-1.08l-1.1-4.73 3.67-3.18a1 1 0 00-.56-1.75z"}})])
          )
        }
      }
    